import React from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Sprites from "styles/images/SpriteIcons.svg";

export function ScoreContainer(props) {
    const { resultObj } = props;
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const result = resultObj?.result;
    const winner = resultObj?.wlt === 'W'
  
    return (
      <div className='score-result-container d-flex justify-content-end align-self-center align-items-center'>
        <div className={`${winner ? 'fw-bold' : ''} `}>
          {result}
        </div> 
        {resultObj?.hasIRM &&
          <div className='score-result fw-bold'>
            <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true} />
          </div>}
      </div>
    )
  }